<template>
  <div class="listSearch">
    <el-input
      v-model.trim="value"
      @clear="$emit('clearSearch')"
      @input="onInput"
      @keyup.enter.native="search"
      :placeholder="$t('placeholder.enter')"
      :clearable="clearable"
    >
    </el-input>
    <button class="global-button-style" @click.stop="search">
      {{ $t("commonMsg.search") }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      value: ""
    };
  },
  methods: {
    onInput() {
      this.search();
    },
    search() {
      this.$emit("listSearchEvn", this.value);
    },
    clearValue() {
      this.value = "";
    }
  },
  created() {
    this.onInput = this.$_.debounce(this.onInput, 1000);
  }
};
</script>

<style lang="scss" scoped>
.listSearch {
  display: flex;
  align-items: center;
  .el-input {
    width: 200px;
    .search-icon {
      font-size: 22px;
      cursor: pointer;
    }
  }
}
</style>
